import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Typography, Box, useTheme } from '@mui/material';
import { InfoOutlined as InfoIcon, ErrorOutline as ErrorIcon, ReportProblemOutlined as WarningIcon, CheckCircleOutline as SuccessIcon, } from '@mui/icons-material';
import cs from 'classnames';
import { colors } from '../../theme';
const defaultBannerIcons = {
    info: InfoIcon,
    success: SuccessIcon,
    warning: WarningIcon,
    error: ErrorIcon,
};
const variantToColor = {
    info: colors.blue[300],
    success: colors.green[300],
    warning: colors.yellow[300],
    error: colors.red[400],
};
export function Banner(props) {
    const { className, message, action, classes = {}, variant = 'info', iconOverrides = {}, messageTypography = 'body1', ...rest } = props;
    const theme = useTheme();
    const icons = { ...defaultBannerIcons, ...iconOverrides };
    const Icon = icons[variant];
    return (_jsxs(Box, { ...rest, className: cs(className, classes.root), css: {
            display: 'flex',
            justifyContent: 'flex-start',
            alignContent: 'center',
            border: '1px solid',
            borderColor: variantToColor[variant],
            backgroundColor: theme.palette.primary.contrastText,
        }, children: [_jsx("div", { className: classes.iconContainer, css: {
                    background: variantToColor[variant],
                    color: theme.palette.primary.contrastText,
                    width: theme.spacing(7),
                    minHeight: theme.spacing(7),
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    flexShrink: 0,
                }, children: _jsx(Icon, { className: classes.icon, "aria-hidden": true, sx: { size: 3 } }) }), _jsx("div", { className: classes.messageContainer, css: {
                    display: 'flex',
                    alignItems: 'center',
                    padding: theme.spacing(2),
                    flexBasis: '100%',
                }, children: _jsx(Typography, { variant: messageTypography, className: classes.message, children: message }) }), action && (_jsx("div", { className: classes.actionContainer, css: {
                    paddingRight: theme.spacing(2),
                    display: 'flex',
                    alignItems: 'center',
                }, children: action }))] }));
}
